import { TransactionRevokeDelegate, TransactionStatus } from '@/features/Transactions/transactions.types'
import React from 'react'
import { TransactionRow } from '../Common/TransactionRow'

export function RevokeDelegate({ transaction, onClick, withoutDate }: {
  onClick: () => void;
  transaction: TransactionRevokeDelegate;
  withoutDate: boolean;
}) {
  return (
    <TransactionRow
      amount="0"
      createdAt={transaction.createdAt}
      iconType="REVOKE_DELEGATE"
      isError={transaction.status === TransactionStatus.ERROR_SEND}
      onClick={onClick}
      status={transaction.status}
      title="Delegation"
      type={null}
      withoutDate={withoutDate}
      mint={transaction.data.mint}
    />
  )
}
